import { connect } from 'react-redux'

import ProjectsLayoutEleven from 'components/home-page/views/sections/projects/layouts/eleven'

const mapStateToProps = (state, ownProps) => ({
  data: state.homePageRevision.revision.sections[ownProps.sectionId].meta.autoAddProjects
    ? ownProps.projects
    : state.homePageRevision.revision.sections[ownProps.sectionId].data,
  meta: state.homePageRevision.revision.sections[ownProps.sectionId].meta,
  theme: state.homePageRevision.revision.sections[ownProps.sectionId].theme
})

export default connect(mapStateToProps)(ProjectsLayoutEleven)
